/* global $ */

(function (scope) {
  "use strict";

  /**
   *
   */
  var PrintModalProductionCenterView = (scope.PrintModalProductionCenterView =
    function (controller, design) {
      this.controller = controller;
      this.design = design;

      this.$el = $("#PrintModalProductionCenterView");
      this.$productionCenteButton = $(".production_center_button .btn");
      this.$productionCenteButton.on("click", this.showModal.bind(this));
      this.productionCenter = null;

      this.$el.on(
        "change",
        "[name=production_center]",
        this.changeProductionCenter.bind(this)
      );
      this.$el.on("submit", "form", this.submitProductionCenter.bind(this));

      this.$el.on("click", ".modal-background", this.hideModal.bind(this));
      this.$el.on(
        "click",
        ".modal-production-center-save",
        this.hideModal.bind(this)
      );

      if (parseInt(this.design.manufacturing_type, 10) === 2) {
        this.initProductionCenter();
        this.updateProductionCenterButtonText(
          this.design.order.production_center
        );
      }
    });

  /**
   * Hide prudction center modal
   * @public
   */
  PrintModalProductionCenterView.prototype.hideModal = function (e) {
    this.$el.hide();
  };

  /**
   * init the right production center a launch
   * @public
   */
  PrintModalProductionCenterView.prototype.initProductionCenter = function (e) {
    // WD-1245
    // we cannot offer the production center in the US anymore
    // has to return EU

    // this.design.order.production_center = $('[name=production_center]:checked').val();
    this.design.order.production_center = 2;

    this.productionCenter = this.design.order.production_center;
    return this.design.order.production_center;
  };

  /**
   * Show prudction center modal
   * @public
   */
  PrintModalProductionCenterView.prototype.showModal = function () {
    this.$el.show();
  };

  /**
   * Change production center
   * @public
   */
  PrintModalProductionCenterView.prototype.changeProductionCenter = function (
    evt
  ) {
    $("label", this.$el).removeClass("checked");
    $(evt.currentTarget).parent().addClass("checked");
  };

  PrintModalProductionCenterView.prototype.submitProductionCenter = function (
    evt
  ) {
    evt.preventDefault();

    this.productionCenter = $(
      "[name=production_center]:checked",
      this.$el
    ).val();

    this.saveProductionCenter(
      this.productionCenter,
      function () {
        this.hideModal();
        this.updateProductionCenterButtonText(this.productionCenter);
        this.controller.updateProductionCenter(this.productionCenter);
      }.bind(this)
    );
  };

  PrintModalProductionCenterView.prototype.saveProductionCenter = function (
    production_center,
    callback
  ) {
    return $.post(
      $("form", this.$el).attr("action"),
      { production_center: production_center },
      callback
    );
  };

  PrintModalProductionCenterView.prototype.updateProductionCenterButtonText =
    function (production_center) {
      var text = gettext("Full Catalog");
      var tagc = "ALL";
      var css = "";

      if (parseInt(production_center, 10) === 1) {
        text = gettext("USA preferred");
        css = "usa";
        tagc = "US";
      } else if (parseInt(production_center, 10) === 2) {
        text = gettext("EU preferred");
        css = "eur";
        tagc = "EU";
      }

      $("[data-production-center-button]")
        .html(text)
        .removeClass("usa eur")
        .addClass(css);
    };
})((window.sculpteo = window.sculpteo || {}));
